import { useState } from 'react';

export const useSelectedSku = (defaultSkuId, privateOffer) =>
    useState(privateOffer && privateOffer.skuId ? privateOffer.skuId : defaultSkuId);
